<template>
  <div class="passport-container">
    <div class="logo-container">
      <div class='logo'><a href=""><img src="../../assets/images/logo.png" height="32px" width="125px"/></a></div>
    </div>
    <div class="passport dialog-form">
      <h1>重置密码</h1>
      <div class="error-tip-container">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
      </div>
      <h3 class="sm-tip" v-if="sendEmailSuccess">密码重置成功</h3>
      <p class="sm-tip" v-if="sendEmailSuccess">
        <a class="normal-content" href="/login">点击此处，使用新密码去登录</a>
        <a class="dialog-content" @click="showLoginDialog()">点击此处，使用新密码去登录</a>
      </p>
      <div v-if="!sendEmailSuccess">
        <div class="text-center" style="height: 280px;padding-top: 90px;" v-show="loading">
          <Loading type="1"></Loading>
        </div>
        <el-form ref="form" :model="form" :rules="rules" v-if="!loading">
          <el-form-item label="" prop="password">
            <YueDanIpt model="password" type="password" :object="form" placeholder="请输入新密码"></YueDanIpt>
          </el-form-item>
          <el-form-item label="" prop="confirmPassword">
            <YueDanIpt model="confirmPassword" type="password" :object="form" placeholder="请确认新密码"></YueDanIpt>
          </el-form-item>
          <div class="btn-container">
            <el-button type="primary block" @click="submit()" :loading="loading">提&nbsp;交</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import YueDanIpt from '../../components/YueDanIpt'
import Loading from '../../components/Loading'
let $ = require('jQuery')

export default {
  name: 'ResetPwdByEmail',
  props: ['isDialog'],
  components: {
    YueDanIpt: YueDanIpt,
    Loading: Loading
  },
  created() {
    this.form.hash = this.$route.query.hash
  },
  data () {
    var checkExist = (rule, value, callback) => {
      if (value == this.form.password) {
         callback();
      } else {
        return callback(new Error('两次密码输入不一致'));
      }
    }
    return {
      form: {
        password: '',
        confirmPassword: '',
      },
      loading: false,
      errors: null,
      isEmptyErrors: true,
      sendEmailSuccess: null,
      rules: {
        confirmPassword: [
          { validator: checkExist, trigger: 'blur' }
        ],
        password: [
          { required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,30}$/, message: '密码长度至少为8 位，且必须同时包含大写字母、小写字母和数字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submit: function () {
      this.$refs['form'].validate((valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          api.post(this, {
            path: 'passport.php',
            data: {
              hash: this.form.hash,
              password: this.form.password,
              password2: this.form.confirmPassword
            },
            loading: 'loading',
            api: 'reset_password'
          }).then((res) => {
            if (res.body.status === 'ok') {
              this.sendEmailSuccess = true
              // this.$emit('success')
            }
          }, err => {

          })
        } else {
          return false;
        }
      })
    },
    showLoginDialog () {
      this.$store.commit('showGlobalDialog', 'loginVisible')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/passport/ResetPwdByEmail.vue